import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';

export function JuristicPerson({
  setFieldValue,
  values,
  handleChange,
  errors,
  touched,
  identitycard,
  handleinputTab,
  prefixNames
}) {
  const prefixOptions =
    prefixNames?.map(item => ({
      value: item.id,
      label: item.name,
      first_name: item.first_name || '',
      last_name: item.last_name || ''
    })) || [];

  useEffect(() => {
    if (prefixOptions.length > 0) {
      const firstPrefix = prefixOptions[0];
      setFieldValue('company_prefix', firstPrefix.first_name || '');
      setFieldValue('company_suffix', firstPrefix.last_name || '');
    }
  }, [prefixNames, setFieldValue]);

  return (
    <div className="px-3">
      <div className="row gx-xl-4">
        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">
              รหัสลูกค้า <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="code"
              className="form-control"
              placeholder="รหัสลูกค้า"
              value={values.code}
              onChange={handleChange}
              isInvalid={touched.code && !!errors.code}
              disabled={true}
            />
            <Form.Control.Feedback type="invalid">{errors.code}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-9 col-md-12">
          <Form.Label className="mb-1 tc-10 fs-12">หมายเลขผู้เสียภาษี (13 หลัก)</Form.Label>
          <div className="my-0 form-st-3 identitycard">
            <div className="d-flex gap-1">
              {Array.from({ length: 13 }, (_, index) => (
                <Form.Control
                  key={index}
                  type="text"
                  maxLength="1"
                  className="form-control text-center"
                  style={{ width: '40px' }}
                  value={identitycard[index] || ''}
                  onChange={e => handleinputTab(e, index)}
                  onKeyDown={e => {
                    if (e.key === 'Backspace' && !e.target.value && index > 0) {
                      const prevInput = document.querySelector(`input[name="identitycard_${index - 1}"]`);
                      if (prevInput) prevInput.focus();
                    } else if (e.target.value && index < 12 && e.key !== 'Backspace') {
                      const nextInput = document.querySelector(`input[name="identitycard_${index + 1}"]`);
                      if (nextInput) nextInput.focus();
                    }
                  }}
                  name={`identitycard_${index}`}
                />
              ))}
            </div>
          </div>
          {touched.tax_number && errors.tax_number && (
            <div className="invalid-feedback d-block">{errors.tax_number}</div>
          )}
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">คำนำหน้า</Form.Label>
            <Form.Control
              type="text"
              name="company_prefix"
              className="form-control"
              placeholder="คำนำหน้า"
              value={values.company_prefix || ''}
              onChange={handleChange}
              isInvalid={touched.company_prefix && !!errors.company_prefix}
              disabled={true}
              style={{ backgroundColor: '#f8f9fa' }}
            />
            <Form.Control.Feedback type="invalid">{errors.company_prefix}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">
              ชื่อ (TH) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="company_name_th"
              className="form-control"
              placeholder="ชื่อบริษัทภาษาไทย"
              value={values.company_name_th}
              onChange={handleChange}
              isInvalid={touched.company_name_th && !!errors.company_name_th}
            />
            <Form.Control.Feedback type="invalid">{errors.company_name_th}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">คำลงท้าย</Form.Label>
            <Form.Control
              type="text"
              name="company_suffix"
              className="form-control"
              placeholder="คำลงท้าย"
              value={values.company_suffix || ''}
              onChange={handleChange}
              isInvalid={touched.company_suffix && !!errors.company_suffix}
              disabled={true}
              style={{ backgroundColor: '#f8f9fa' }}
            />
            <Form.Control.Feedback type="invalid">{errors.company_suffix}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">เบอร์โทรศัพท์</Form.Label>
            <Form.Control
              type="text"
              name="phone_number"
              className="form-control"
              placeholder="เบอร์โทรศัพท์"
              value={values.phone_number}
              onChange={handleChange}
              isInvalid={touched.phone_number && !!errors.phone_number}
            />
            <Form.Control.Feedback type="invalid">{errors.phone_number}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">คะแนน</Form.Label>
            <Form.Control
              type="number"
              name="totalPoint"
              className="form-control"
              placeholder="คะแนน"
              value={values.totalPoint}
              onChange={handleChange}
              isInvalid={touched.totalPoint && !!errors.totalPoint}
              disabled={true}
            />
            <Form.Control.Feedback type="invalid">{errors.totalPoint}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">Line</Form.Label>
            <Form.Control
              type="text"
              name="line_uid"
              className="form-control"
              placeholder="Line"
              value={values.line_uid ? 'เชื่อมต่อแล้ว' : '-'}
              onChange={handleChange}
              isInvalid={touched.line_uid && !!errors.line_uid}
              disabled={true}
              style={values.line_uid ? { color: '#2DC76D', fontSize: '14px' } : {}}
            />
            <Form.Control.Feedback type="invalid">{errors.line_uid}</Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="col-xl-3 col-md-6">
          <Form.Group className="mb-3 form-st-3 pb-1">
            <Form.Label className="mb-1">Facebook</Form.Label>
            <Form.Control
              type="text"
              name="facebook"
              className="form-control"
              placeholder="Facebook"
              value={values.facebook ? 'เชื่อมต่อแล้ว' : '-'}
              onChange={handleChange}
              isInvalid={touched.facebook && !!errors.facebook}
              disabled={true}
              style={values.facebook ? { color: '#2DC76D', fontSize: '14px' } : {}}
            />
            <Form.Control.Feedback type="invalid">{errors.facebook}</Form.Control.Feedback>
          </Form.Group>
        </div>
      </div>
    </div>
  );
}
